export const verificarPermissao = permission => {
  const permissionUserData = JSON.parse(localStorage.getItem('userData'))
  if (!permissionUserData || !permissionUserData.ability) return false

  const permissions = Array.isArray(permission) ? permission : [permission]

  return permissions.some(p => permissionUserData.ability.some(item => item.action === p))
}
